
import { Navigation } from "swiper";
import ShopByOfferTile from "../ShopByOffer/ShopByOfferTile.vue";

export default {
  name: "ShopByOfferV2",

  components: {
    ShopByOfferTile,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      swiperClass: "shop-by-offer-v2-swiper",
      swiper: null,
      swiperIsBeginning: true,
      swiperIsEnd: false,
    };
  },

  computed: {
    displayCarousel() {
      return this.slice?.primary?.list_type;
    },

    showMobileNav() {
      return (this.slice?.items || []).length > 1;
    },

    swiperOptions() {
      return {
        slidesPerView: 1.5,
        slidesPerGroup: 1,
        spaceBetween: 12,
        breakpoints: {
          744: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 12,
          },
          1024: {
            slidesPerView: "auto",
            slidesPerGroup: 4,
            spaceBetween: 0,
          },
        },
        modules: [Navigation],
        navigation: {
          nextEl: `.${this.swiperClass}-next`,
          prevEl: `.${this.swiperClass}-prev`,
        },
      };
    },
  },

  async mounted() {
    if (this.displayCarousel) {
      await this.initSwiper();
    }
  },

  destroyed() {
    if (this.displayCarousel) {
      this.destroySwiper();
    }
  },

  methods: {
    async initSwiper() {
      await this.$nextTick();
      let swiper = await this.$swiper.init(
        `.swiper.${this.swiperClass}`,
        this.swiperOptions
      );
      if (Array.isArray(swiper)) {
        swiper = swiper[0] ?? null;
      }
      this.swiper = swiper;
      if (this.swiper) {
        this.swiperIsBeginning = this.swiper.isBeginning;
        this.swiperIsEnd = this.swiper.isEnd;
        this.swiper.on("slideChange", this.onSwiperSlideChange);
        this.swiper.on("reachBeginning", this.onSwiperSlideChange);
        this.swiper.on("reachEnd", this.onSwiperSlideChange);
      }
    },
    destroySwiper() {
      const swiper = this.swiper;
      if (swiper && typeof swiper.off === "function") {
        swiper.off("slideChange", this.onSwiperSlideChange);
        swiper.off("reachBeginning", this.onSwiperSlideChange);
        swiper.off("reachEnd", this.onSwiperSlideChange);
      }
      this.$swiper.destroy(`.swiper.${this.swiperClass}`);
      this.swiper = null;
      this.swiperIsBeginning = true;
      this.swiperIsEnd = false;
    },
    onSwiperSlideChange() {
      if (!this.swiper) return;
      this.swiperIsBeginning = this.swiper.isBeginning;
      this.swiperIsEnd = this.swiper.isEnd;
    },
    mobileSlide(direction) {
      if (!this.swiper) return;
      if (direction < 0) {
        this.swiper.slidePrev();
      } else {
        this.swiper.slideNext();
      }
    },
  },
};
